export const singularPluralPointsDisplay = (value: number) => {
	if (value > 1) {
		return "Punkte";
	} else return "Punkt";
};
